/* Native scrolling and deliberate, cancellable motion. The navigation never moves. */
(()=>{
 'use strict';
 const $=s=>document.querySelector(s),$$=s=>[...document.querySelectorAll(s)];
 const reduce=matchMedia('(prefers-reduced-motion: reduce)');
 const ease='cubic-bezier(.16,1,.3,1)';
 const running=new Set(), touched=new WeakMap();
 function play(el,frames,options={}){
  if(!el||reduce.matches)return;
  const a=el.animate(frames,{duration:900,easing:ease,...options});running.add(a);
  a.finished.catch(()=>{}).finally(()=>running.delete(a));return a;
 }
 // SVG strokes use the element's CSS color; mobile emoji fonts cannot replace them.
 const paths={'↗':'M5 19L19 5M5 5H19V19','→':'M4 12H20M13 5L20 12L13 19','←':'M20 12H4M11 5L4 12L11 19','↑':'M12 20V4M5 11L12 4L19 11','↓':'M12 4V20M5 13L12 20L19 13','⤢':'M4 10V4H10M4 4L10 10M14 14L20 20M14 20H20V14','↔':'M4 12H20M9 7L4 12L9 17M15 7L20 12L15 17'};
 const arrowPattern=/([↗→←↑↓⤢↔])\uFE0E?/g;
 function arrowIcon(symbol){
  const svg=document.createElementNS('http://www.w3.org/2000/svg','svg');
  svg.setAttribute('viewBox','0 0 24 24');svg.setAttribute('class','kl-arrow');svg.setAttribute('aria-hidden','true');svg.setAttribute('focusable','false');
  const path=document.createElementNS(svg.namespaceURI,'path');path.setAttribute('d',paths[symbol]);svg.append(path);return svg;
 }
 function normalizeArrows(){
  const nodes=[];
  const walker=document.createTreeWalker(document.body,NodeFilter.SHOW_TEXT,{acceptNode(node){return node.parentElement?.closest('a,button')&&!node.parentElement?.closest('svg,script,style')&&/[↗→←↑↓⤢↔]/.test(node.data)?NodeFilter.FILTER_ACCEPT:NodeFilter.FILTER_REJECT;}});
  while(walker.nextNode())nodes.push(walker.currentNode);
  for(const node of nodes){
   const parts=node.data.split(arrowPattern),fragment=document.createDocumentFragment();
   parts.forEach(part=>fragment.append(paths[part]?arrowIcon(part):document.createTextNode(part)));node.replaceWith(fragment);
  }
 }
 normalizeArrows();
 const iconObserver=new MutationObserver(normalizeArrows);iconObserver.observe(document.body,{childList:true,subtree:true});
 if(!document.body.matches('.pdp,[data-storefront]'))return;
 const progress=document.createElement('div');progress.className='experience-progress';progress.setAttribute('aria-hidden','true');document.body.append(progress);
 let frame=0;
 function update(){frame=0;const max=document.documentElement.scrollHeight-innerHeight;progress.style.scale=(max>0?Math.max(0,Math.min(scrollY/max,1)):0)+' 1';}
 addEventListener('scroll',()=>{if(!frame)frame=requestAnimationFrame(update);},{passive:true});addEventListener('resize',update);update();
 function revealTitle(){
  const title=$('#hero-title');if(!title)return;
  title.getAnimations({subtree:true}).filter(a=>!('animationName'in a)).forEach(a=>a.cancel());
  [...title.children].forEach((line,i)=>play(line,[{opacity:0,translate:'0 24px',clipPath:'inset(0 0 100% 0)'},{opacity:1,translate:'0 0',clipPath:'inset(0)'}],{duration:1000,delay:i*110}));
  const description=$('#hero-description');touched.get(description)?.cancel();touched.set(description,play(description,[{opacity:0,translate:'0 10px'},{opacity:1,translate:'0 0'}],{duration:700,delay:130}));
 }
 const stage=$('.hero-visual');let light;
 if(stage){light=document.createElement('span');light.className='scene-light';light.setAttribute('aria-hidden','true');stage.append(light);}
 function sweep(){if(!light)return;touched.get(light)?.cancel();touched.set(light,play(light,[{opacity:0,backgroundPosition:'200% 0'},{opacity:.3,offset:.42},{opacity:0,backgroundPosition:'-100% 0'}],{duration:1700}));}
 if(document.body.hasAttribute('data-storefront')){
  if(!document.documentElement.classList.contains('shop-entering')){
   revealTitle();play($('.bold-stage'),[{opacity:0,translate:'0 30px',scale:'.97'},{opacity:1,translate:'0 0',scale:'1'}],{duration:1250,delay:100});
  }
  let current=document.body.dataset.product;
  new MutationObserver(()=>{const next=document.body.dataset.product;if(next!==current){current=next;revealTitle();sweep();}}).observe(document.body,{attributes:true,attributeFilter:['data-product']});
 }
 // A single reveal per card. Existing heading and product animations keep their own layers.
 const pending=new Set();
 if('IntersectionObserver'in window){
  const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
   if(!entry.isIntersecting)return;const el=entry.target;pending.delete(el);el.classList.add('motion-seen');
   if(!reduce.matches){
    const photo=el.matches('.inspiration-photo,.pdp-story-image,.support-photo');
    if(photo)play(el.querySelector('img'),[{opacity:.4,scale:'1.09',clipPath:'inset(6% 0 0)'},{opacity:1,scale:'1',clipPath:'inset(0)'}],{duration:1450});
    else play(el,[{opacity:0,translate:'0 38px',scale:'.965'},{opacity:1,translate:'0 0',scale:'1'}],{duration:1000,delay:Number(el.dataset.motionDelay)||0});
   }
   observer.unobserve(el);
  }),{threshold:.08,rootMargin:'0px 0px -12px 0px'});
  $$('.catalog-piece,.collection-card .card-image,.inspiration-photo,.pdp-story-image,.support-photo').forEach((el,i)=>{
   el.dataset.motionDelay=String(el.matches('.catalog-piece')?(i%4)*65:0);
   if(!reduce.matches)el.classList.add('motion-await');pending.add(el);observer.observe(el);
  });
  reduce.addEventListener('change',()=>{if(reduce.matches){pending.forEach(el=>el.classList.add('motion-seen'));running.forEach(a=>a.cancel());}});
 }
 // Tactile response without following the pointer or changing the layout.
 document.addEventListener('pointerdown',event=>{
  if(event.button!==0||reduce.matches)return;
  const target=event.target.closest('button,.discover,.path-card,.catalog-piece,.pdp-related-card');
  if(!target||target.disabled)return;
  touched.get(target)?.cancel();touched.set(target,play(target,[{scale:'1'},{scale:'.982',offset:.3},{scale:'1'}],{duration:460}));
 },{passive:true});
 document.addEventListener('click',event=>{
  const selected=event.target.closest('[data-choice]');
  if(selected)play($('#pdp-selected-name'),[{opacity:.15,translate:'0 8px'},{opacity:1,translate:'0 0'}],{duration:550});
 });
 // Height animation follows the native details state, so keyboard operation is preserved.
 $$('details').forEach(details=>{
  const content=document.createElement('div');content.className='accordion-motion-content';
  [...details.children].filter(el=>el.tagName!=='SUMMARY').forEach(el=>content.append(el));details.append(content);
  details.addEventListener('toggle',()=>{if(details.open){touched.get(content)?.cancel();touched.set(content,play(content,[{opacity:0,translate:'0 -9px'},{opacity:1,translate:'0 0'}],{duration:550}));}});
 });
 document.documentElement.dataset.experienceReady='true';
})();
